import { render } from "./SendingDomains.vue?vue&type=template&id=2b5f6302"
import script from "./SendingDomains.vue?vue&type=script&lang=js"
export * from "./SendingDomains.vue?vue&type=script&lang=js"

import "./SendingDomains.vue?vue&type=style&index=0&id=2b5f6302&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__